module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_e1221876.e9d80bfa.woff";